import { types, flow, getSnapshot } from "mobx-state-tree";
import axios from 'axios';
import persist from 'mst-persist';
import { FetchApi, FetchApiNoParam, apiClient } from "./utils/api";

const BASE_URL =  "https://backoffice.primulahotels.com/console/"
export const API_KEY = "renai202509221613"
export const API_TOKEN = "biBh98y78GHJ564e6fu1ghBJB"

// Types for API parameters
interface FetchApiParameters {
  [key: string]: string | number | undefined;
}

interface TableSearchParameters {
  name?: string;
  date?: string;
  voucher_code?: string;
}

interface RoomSearchParameters {
  [key: string]: string | number | undefined;
}

interface LoginParameters {
  [key: string]: string | number | undefined;
}

interface RegistrationParameters {
  [key: string]: string | number | undefined;
}

interface ProfileParameters {
  [key: string]: string | number | undefined;
}

interface BookingParameters {
  [key: string]: string | number | undefined;
}

interface AddonParameters {
  addon_code: string;
  pax: number;
  night: number;
}

interface ApiResponse {
  status?: number;
  error_code?: string;
  [key: string]: any;
}

// const FetchApi = (path: string, parameters: FetchApiParameters): string => {
//   let query = "";
//   let api_key = API_KEY
//   let api_token = API_TOKEN
//   let url = BASE_URL + 'api/'
//   for (let key in parameters) {
//     let value = parameters[key];
//     if (value !== undefined) {
//       query += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
//     }
//   }
//   if (query.length > 0) {
//     query = query.substring(0, query.length - 1);
//     url = url + path + "?" + "apikey" + "=" + api_key + "&" + "apitoken" + "=" + api_token + "&" + query;
//   }
//   return url;
// }

// const FetchApiNoParam = (path: string): string => {
//   let api_key = API_KEY
//   let api_token = API_TOKEN
//   let url = BASE_URL + 'api/'
//   url = url + path + "?" + "apikey" + "=" + api_key + "&" + "apitoken" + "=" + api_token
//   return url;
// }

const General = types.model({
  companyDetails: types.optional(types.map(types.frozen()), {}),
})
.actions(self => {
	const fetchCompanyDetails = flow(function* () {
		try {
			const url = FetchApiNoParam("Company_Details.php")
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchCompanyDetails", response.data)
				self.companyDetails = response.data
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchCompanyDetails", response.data)
				self.companyDetails.clear()
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchCompanyDetails", err)
			self.companyDetails.clear()
			return Promise.reject(err)
		}
	});
	
	const fetchImageSlides = flow(function* () {
		try {
			const url = FetchApiNoParam("Image_Slider.php")
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchImageSlides", response.data)
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchImageSlides", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchImageSlides", err)
			return Promise.reject(err)
		}
	});
	
	const fetchStates = flow(function* () {
		const url = FetchApiNoParam("state.php");
		console.log("Full URL:", url);
		
		try {
			const response = yield apiClient.get(url);
			console.log("Full response:", response);
			console.log("Status:", response.status);
			console.log("Headers:", response.headers);
			console.log("Data:", response.data);
			
			return response.data;
		} catch (error: any) {
			console.error("Full error details:", {
				message: error.message,
				response: error.response,
				status: error.response?.status,
				data: error.response?.data
			});
			throw error;
		}
	});

	const fetchTables = flow(function* (parameters?: TableSearchParameters) {
		try {
			const url = FetchApi("table_search.php", {
				name: parameters?.name,
				date: parameters?.date,
				voucher_code: parameters?.voucher_code || ''
			})
			console.log("URL ======= fetchTables", url)
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchTables", response.data)
				return Promise.resolve([response.data])
			} else {
				console.log("Invalid Response ======= fetchTables", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchTables", err)
			return Promise.reject(err)
		}
	});

	const fetchRestaurants = flow(function* () {
		try {
			const url = FetchApiNoParam("restaurant_list.php")
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchRestaurants", response.data)
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchRestaurants", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchRestaurants", err)
			return Promise.reject(err)
		}
	});

	const fetchCountries = flow(function* () {
		try {
			const url = FetchApiNoParam("country.php")
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchCountries", response.data)
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchCountries", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchCountries", err)
			return Promise.reject(err)
		}
	});
	
	const fetchRooms = flow(function* (parameters: RoomSearchParameters) {
		try {
			const url = FetchApi("Room_Search.php", parameters)
			console.log("check url fetchRooms ===> ", url)
			const response: { data: any } = yield apiClient.get(url)
			if (response.data[0].status === undefined) {
				console.log("Valid Response ======= fetchRooms", response.data)
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchRooms", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchRooms", err)
			return Promise.reject(err)
		}
	});
	
	return { 
		fetchCompanyDetails, 
		fetchImageSlides, 
		fetchStates, 
		fetchTables, 
		fetchRestaurants, 
		fetchCountries, 
		fetchRooms 
	}
})

export const mstGeneral = General.create({})

const Auth = types.model({
  isLoggedIn: types.optional(types.boolean, false),
  user: types.optional(types.map(types.frozen()), {}),
})
.actions(self => {
	const register = flow(function* (parameters: RegistrationParameters) {
		try {
			const url = FetchApi("registration.php", parameters)
			const response: { data: ApiResponse } = yield apiClient.get(url)
			console.log("check url registration ===> ", url)
			console.log("check response registration ===> ", response)
			if (response.data.status === 1) {
				console.log("valid response registration ===> ", response)
				return Promise.resolve(response.data)
			} else {
				console.log("invalid response registration ===> ", response)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("catch error registration ===> ", err)
			return Promise.reject(err)
		}
	})
	
	const forgotPassword = flow(function* (parameters: FetchApiParameters) {
		try {
			const url = FetchApi("forgot_password", parameters)
			const response: { data: ApiResponse } = yield apiClient.get(url)
			console.log("check url forgotPassword ===> ", url)
			console.log("check response forgotPassword ===> ", response)
			if (response.data.error_code === undefined) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response.data)
			}
		} catch (err) {
			return Promise.reject(err)
		}
	})
	
	const registrationVerify = flow(function* (parameters: RegistrationParameters) {
		try {
			const url = FetchApi("registration_verify.php", parameters)
			const response: { data: ApiResponse } = yield apiClient.get(url)
			console.log("check url registrationVerify ===> ", url)
			console.log("check response registrationVerify ===> ", response)
			if (response.data.status === 1) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response.data)
			}
		} catch (err) {
			return Promise.reject(err)
		}
	})
	
	const login = flow(function* (parameters: LoginParameters) {
		console.log("chck parameters login ===> ", parameters)
		try {
			const url = FetchApi("member_login.php", parameters)
			console.log("check url login ===> ", url)
			const response: { data: ApiResponse } = yield apiClient.get(url)
			if (response.data.status === 1) {
				console.log("Valid Response ======= login", response.data)
				self.isLoggedIn = true
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= login", response.data)
				self.isLoggedIn = false
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= login", err)
			self.isLoggedIn = false
			return Promise.reject(err)
		}
	});
	
	const logout = flow(function* () {
		try {
			self.isLoggedIn = false
			self.user.clear()
			return Promise.resolve(true)
		} catch (err) {
			console.log("Catch Error ======= logout", err)
			return Promise.reject(err)
		}
	});
	
	const fetchUserProfile = flow(function* (parameters: ProfileParameters) {
		try {
			const url = FetchApi("member_profile.php", parameters)
			const response: { data: any } = yield apiClient.get(url)
			if (response.data) {
				console.log("Valid Response ======= fetchUserProfile", response.data)
				self.user = response.data
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchUserProfile", response.data)
				self.user.clear()
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchUserProfile", err)
			self.user.clear()
			return Promise.reject(err)
		}
	});
	
	const updateUserProfile = flow(function* (parameters: ProfileParameters) {
		try {
			const url = FetchApi("update_profile.php", parameters)
			const response: { data: any } = yield apiClient.get(url)
			console.log("check url updateUserProfile ===> ", url)
			console.log("check response updateUserProfile ===> ", response)
			if (response.data) {
				console.log("Valid Response ======= updateUserProfile", response.data)
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= updateUserProfile", response.data)
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= updateUserProfile", err)
			return Promise.reject(err)
		}
	});
	
	return { 
		register, 
		registrationVerify, 
		login, 
		logout, 
		forgotPassword, 
		fetchUserProfile, 
		updateUserProfile 
	}
})

export const mstAuth = Auth.create({})

const Booking = types.model({
  bookings: types.optional(types.array(types.frozen()), []),
})
.actions(self => {
	const fetchBookings = flow(function* (parameters: BookingParameters) {
		try {
			const url = FetchApi("list_booking.php", parameters)
			console.log("check url fetchBookings ===> ", url)
			const response: { data: any } = yield apiClient.get(url)
			if (response?.data[0]?.status === undefined) {
				console.log("Valid Response ======= fetchBookings", response.data)
				self.bookings = response.data
				return Promise.resolve(response.data)
			} else {
				console.log("Invalid Response ======= fetchBookings", response.data)
				self.bookings.clear()
				return Promise.reject(response.data)
			}
		} catch (err) {
			console.log("Catch Error ======= fetchBookings", err)
			self.bookings.clear()
			return Promise.reject(err)
		}
	});
	
	const singleBooking = flow(function* (parameters: BookingParameters) {
		try {
			const url = FetchApi("single_booking.php", parameters)
			console.log("check url singleBooking ===> ", url)
			const response: { data: any[] } = yield apiClient.get(url)
			console.log("Valid Response ======= singleBooking", response.data[0])
			return Promise.resolve(response.data[0])
		} catch (err) {
			console.log("Catch Error ======= singleBooking", err)
			return Promise.reject(err)
		}
	});
	
	const createBooking = flow(function* (parameters: BookingParameters, addonParameters: AddonParameters[]) {
		try {
			const addonParams = addonParameters.map((i, idx) => { 
				return `addon[${idx}][addon_code]=${i.addon_code}&addon[${idx}][pax]=${i.pax}&addon[${idx}][night]=${i.night}` 
			}).join("&")
			const url = FetchApi('create_booking.php', parameters) + "&" + addonParams
			console.log("check url createBooking ===> ", url)
			const response: { data: any[] } = yield apiClient.get(url)
			if (response.data[0].status === 1) {
				console.log("Response success ======= createBooking", response.data[0])
				return Promise.resolve(response.data[0])
			} else {
				console.log("Response failed ======= createBooking", response.data[0])
				return Promise.reject(response.data[0])
			}
		} catch (err) {
			console.log("Catch Error ======= createBooking", err)
			return Promise.reject(err)
		}
	});
	
	const createPayment = flow(function* (parameters: BookingParameters) {
		try {
			const url = FetchApi('ipay', parameters)
			console.log("check url createPayment ===> ", url)
			return Promise.resolve(url)
		} catch (err) {
			console.log("Catch Error ======= createPayment", err)
			return Promise.reject(err)
		}
	});

	const checkPaymentStatus = flow(function* (parameters: BookingParameters) {
		try {
			const url = FetchApi('payment_status.php', parameters)
			console.log("check url checkPaymentStatus ===> ", url)
			const response: { data: any } = yield apiClient.get(url)
			console.log("check response checkPaymentStatus ===> ", response.data)
			return Promise.resolve(response.data)
		} catch (err) {
			console.log("Catch Error ======= checkPaymentStatus", err)
			return Promise.reject(err)
		}
	})
	
	return { 
		fetchBookings, 
		singleBooking, 
		createBooking, 
		createPayment, 
		checkPaymentStatus 
	}
});

export const mstBooking = Booking.create({})

// Persist stores
persist('mstGeneral', mstGeneral, { 
  storage: localStorage, 
  jsonify: true 
}).then(() => console.log('mstGeneral has been persisted'))

persist('mstAuth', mstAuth, { 
  storage: localStorage, 
  jsonify: true 
}).then(() => console.log('mstAuth has been persisted'))

// persist('mstBooking', mstBooking, { 
//   storage: localStorage, 
//   jsonify: true 
// }).then(() => console.log('mstBooking has been persisted'))